// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__27kB1","signatureButtonsRight":"ModalSign_signatureButtonsRight__1v88S"};